import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { supabaseClient } from "../utils/supabase";
import type { Entry } from "./useSelectEntry";

export interface ProfileEntry extends Entry {
    created_at: string;
    notes: string | null;
    at_sea: boolean | null;
    at_sea_all_day: boolean | null;
    [key: string]: any;
}

export function useProfileEntries(
    profileId: string | undefined,
    options?: Omit<UseQueryOptions<ProfileEntry[]>, "queryKey" | "queryFn">
) {
    return useQuery({
        queryKey: ["profile-entries", profileId],
        queryFn: async (): Promise<ProfileEntry[]> => {
            if (!profileId) return [];

            const { data, error } = await supabaseClient
                .from("entries")
                .select(
                    "entry_id, profile_id, created_at, updated_at, submitted_at, notes, at_sea, at_sea_all_day, at_sea_intervals, on_duty_intervals, glucose_issue"
                )
                .eq("profile_id", profileId)
                .order("created_at", { ascending: false });

            if (error) {
                console.error("Failed to fetch entries for profile:", error);
                throw error;
            }

            return (data ?? []) as ProfileEntry[];
        },
        enabled: !!profileId,
        ...options,
    });
}
